import React from 'react';
import mainTpl from '../templates/depositCreditOrdinary';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'get-services'
        };
    }

    static displayName = 'DepositCredit.Views.Main';
}
